import "./Services.css";
import "./ResponsiveServices.css";
import { getTranslatedText as translate } from "../Localization/Translation";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";

function Services() {
  const { locale, servicesRef } = useBetween(
    useSelector((state) => state.useSharedLang)
  );

  return (
    <div className="Services" ref={servicesRef}>
      <div className="section-name">{translate("services-header", locale)}</div>

      {/* service row */}
      <div className="service-row row" dir={locale === "AR" ? "rtl" : "ltr"}>
        {/* Image */}
        <div className="image-col-services col">
          <div className="image-border-services">
            <i className="bi bi-boxes"></i>
          </div>
        </div>

        {/* details */}
        <div className="text-col-services col">
          <div className="card card-service" style={{ width: "18rem" }}>
            <div className="card-body card-body-service" dir="auto">
              <h5 className="card-title card-title-services">
                {translate("first-service-header", locale)}
              </h5>
              <p className="card-text">
                {translate("first-service-content", locale)}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* service row */}
      <div className="service-row row" dir={locale === "AR" ? "rtl" : "ltr"}>
        {/* details */}
        <div className="text-col-services col">
          <div className="card card-service" style={{ width: "18rem" }}>
            <div className="card-body card-body-service" dir="auto">
              <h5 className="card-title card-title-services">
                {translate("second-service-header", locale)}
              </h5>
              <p className="card-text">
                {translate("second-service-content", locale)}
              </p>
            </div>
          </div>
        </div>

        {/* Image */}
        <div className="image-col-services col">
          <div className="image-border-services">
            <i className="bi bi-hand-thumbs-up"></i>
          </div>
        </div>
      </div>

      {/* service row */}
      <div className="service-row row" dir={locale === "AR" ? "rtl" : "ltr"}>
        {/* Image */}
        <div className="image-col-services col">
          <div className="image-border-services">
            <i className="bi bi-currency-exchange"></i>
          </div>
        </div>

        {/* details */}
        <div className="text-col-services col">
          <div className="card card-service" style={{ width: "18rem" }}>
            <div className="card-body card-body-service" dir="auto">
              <h5 className="card-title card-title-services">
                {translate("third-service-header", locale)}
              </h5>
              <p className="card-text">
                {translate("third-service-content", locale)}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* service row */}
      <div className="service-row row" dir={locale === "AR" ? "rtl" : "ltr"}>
        {/* details */}
        <div className="text-col-services col">
          <div className="card card-service" style={{ width: "18rem" }}>
            <div className="card-body card-body-service" dir="auto">
              <h5 className="card-title card-title-services">
                {translate("fourth-service-header", locale)}
              </h5>
              <p className="card-text">
                {translate("fourth-service-content", locale)}
              </p>
            </div>
          </div>
        </div>

        {/* Image */}
        <div className="image-col-services col">
          <div className="image-border-services">
            <i className="bi bi-person-workspace"></i>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
